import { renderImage } from '@src/utilities/renderImage';
import { Popover } from 'antd';
import { ReactNode, useEffect, useState } from 'react';
import { CiUser } from 'react-icons/ci';
import { PiSignOutBold } from 'react-icons/pi';
import { Link } from 'react-router-dom';
import { useTheme, withTheme } from '../ThemeProvider';
import { Image } from './Image';

export interface NavigationItem {
    key: number;
    label: string;
    icon?: ReactNode;
    path: string;
    onClickHandler: () => void;
}

export interface NavigationBarProps {
    title?: string | ReactNode;
    items?: NavigationItem[];
    onSignOut: () => void;
    customSignOutIcon?: ReactNode;
    customUserIcon?: ReactNode;
    customDropdownIcon?: ReactNode;
    className?: string;
    popoverPlacement?: 'bottomRight' | 'bottomLeft' | 'topRight' | 'topLeft';
    signOutLabel?: string;
    user?: any;
    backgroundColor?: string;
    children?: ReactNode;
}

const defaultItems: NavigationItem[] = [
    {
        key: 0,
        label: 'Profile',
        icon: <CiUser className="w-4 h-4 mr-3" />,
        path: '#',
        onClickHandler: () => {},
    },
];

export function NavigationBarComponent({
    title,
    items = defaultItems,
    onSignOut,
    customSignOutIcon,
    className = '',
    popoverPlacement = 'bottomRight',
    signOutLabel = 'Sign Out',
    user,
    backgroundColor = '#4C4C4C0A',
    children,
}: NavigationBarProps) {
    const { theme } = useTheme();
    const [open, setOpen] = useState(false);
    const [renderImg, setRenderImg] = useState(
        <Image avatar_src={'avatar'} isImageRender={false} />
    );

    useEffect(() => {
        if (user) {
            const { picture } = user;
            renderImage(picture!)
                .then(() => {
                    setRenderImg(
                        <Image avatar_src={picture} isImageRender={true} />
                    );
                })
                .catch((err: any) => {
                    console.log('err', err);
                });
        }
    }, [user]);

    const handleSignOut = () => {
        onSignOut();
        handleOpenChange(false);
    };

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    const userContent = (
        <div>
            <div className="max-w-[280px] sm:max-w-full">
                <ul className="mb-0">
                    {items.map(({ icon, key, label, onClickHandler }) => (
                        <li key={key}>
                            <Link
                                to={'#'}
                                className="inline-flex items-center appearance-none
                hover:bg-gray-5 text-light
                w-full px-2 sm:px-3 py-1.5 sm:py-2 mb-1 sm:mb-2 rounded-md text-sm text-primary transition-all
                hover:text-secondary ease-in-out delay-150"
                                onClick={(e) => {
                                    e.preventDefault();
                                    onClickHandler();
                                    handleOpenChange(false);
                                }}
                                style={{
                                    color: theme.colors.secondary.main.text,
                                }}
                            >
                                {icon && (
                                    <span className="w-4 h-4 mr-2 sm:mr-3">
                                        {icon}
                                    </span>
                                )}
                                {label}
                            </Link>
                        </li>
                    ))}
                    <li className="border-t border-primary/20">
                        <Link
                            to="#"
                            className="inline-flex items-center appearance-none
                 rounded-md text-light
                 w-full hover:text-secondary px-2 sm:px-3 py-1.5 sm:py-2 mt-1 sm:mt-2 text-sm transition-all ease-in-out delay-150"
                            onClick={(e) => {
                                e.preventDefault();
                                handleSignOut();
                            }}
                            style={{
                                color: theme.colors.secondary.main.text,
                            }}
                        >
                            {customSignOutIcon || (
                                <PiSignOutBold className="w-4 h-4 mr-2 sm:mr-3" />
                            )}
                            {signOutLabel}
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );

    return (
        <div
            className={`flex items-center justify-between w-full gap-2 sm:gap-4 py-2 sm:py-4 px-3 sm:px-6 ${className}`}
        >
            {typeof title === 'string' ? (
                <h1
                    className="text-base sm:text-lg md:text-2xl font-bold truncate max-w-[200px] sm:max-w-none"
                    style={{ color: theme.colors.secondary.main.text }}
                >
                    {title}
                </h1>
            ) : (
                title
            )}
            <Popover
                placement={popoverPlacement}
                content={userContent}
                arrow={false}
                trigger={'click'}
                open={open}
                onOpenChange={handleOpenChange}
                className="mobile-popover"
            >
                <div
                    className="flex items-center text-light whitespace-nowrap cursor-pointer p-1.5 sm:p-2 rounded-xl gap-2 sm:gap-4"
                    style={{ backgroundColor: backgroundColor }}
                >
                    {children}
                    {renderImg}
                </div>
            </Popover>
        </div>
    );
}
const NavigationBar = withTheme(NavigationBarComponent);
export { NavigationBar };
